/**
 * @generated SignedSource<<a00761dc6434d52b6cedc4ce1f8bc534>>
 * @relayHash 7544ddf3e6c84ccb96fb83530a0c3a7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c959e7e3b9c224719f347459e41f4cb43e93f1e8dd2a67109483c3f9834336ba

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useForgeAppQuery_appByIdQuery$variables = {
  appAri: string;
};
export type useForgeAppQuery_appByIdQuery$data = {
  readonly app: {
    readonly name: string;
    readonly privacyPolicy: string | null | undefined;
    readonly termsOfService: string | null | undefined;
  };
};
export type useForgeAppQuery_appByIdQuery = {
  response: useForgeAppQuery_appByIdQuery$data;
  variables: useForgeAppQuery_appByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "privacyPolicy"
},
v4 = {
  "kind": "ScalarField",
  "name": "termsOfService"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useForgeAppQuery_appByIdQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ]
        },
        "action": "THROW",
        "path": "app"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useForgeAppQuery_appByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c959e7e3b9c224719f347459e41f4cb43e93f1e8dd2a67109483c3f9834336ba",
    "metadata": {},
    "name": "useForgeAppQuery_appByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fec1b71bedaf903d5c8cb1a6493280cd";

export default node;
